/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/risk-evaluation.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import { getProcessedFieldChangeItems, getFieldChangeItems } from 'views/pages/admin/audit-log/service';

const RiskEvaluationRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
        Detectability: oldRecord.Detectability > 0 ? oldRecord.Detectability : null,
        Type: undefined,
        JustificationForChange: oldRecord.ChangeReason,
        ChangeReason: null,
        Movement: oldRecord.Movement > 0 ? oldRecord.Movement : undefined,
        Score: oldRecord.Score > 0 ? oldRecord.Score : undefined,
    };
    const refactoredNewRecord = {
        ...newRecord,
        Detectability: newRecord.Detectability > 0 ? newRecord.Detectability : null,
        Type: undefined,
        JustificationForChange: newRecord.ChangeReason,
        ChangeReason: null,
        Movement: newRecord.Movement > 0 ? newRecord.Movement : undefined,
    };

    const enums: any = {
        Type: AuditEnumValues.EvaluationType,
        Colour: AuditEnumValues.EvaluationColour,
        Movement: AuditEnumValues.EvaluationTrend,
    };

    const lookups: any = {
        EvaluationModelId: (evaluation: any) => evaluation?.evaluationModel?.name,
    };

    const enumMarkerByField = {
        Movement: '_TREND_TYPE',
        Colour: '_COLOUR_TYPE',
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            enums,
            lookups,
            associations: undefined,
            listOfObjects: undefined,
            arrayOfObjects: undefined,
            enumMarkerByField,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { RiskEvaluationRecordChangeGrid };
